module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Gestione Utenti","pageMetaDescription":"Gestisci gli utenti","linkUserList":"Elenco utenti","addPhotographer":"Nuovo Fotografo","addClient":"Nuovo Cliente","addClientSubAccount":"Nuovo E-mail cliente"},"en":{"pageTitle":"User Management","pageMetaDescription":"Manage your users","linkUserList":"All users"}}')
  delete Component.options._Ctor
}
